<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 640 480">
    <path style="fill:#af1d29; stroke:none;" d="M0 0L0 86L434 86L434 0L0 0z"/>
    <path style="fill:#c15f4b; stroke:none;" d="M0 86L0 87L434 87C423.973 82.7923 406.896 86 396 86L307 86L0 86z"/>
    <path style="fill:#ffffff; stroke:none;" d="M0 87L0 172L433 172L433 259L0 259L0 260L434 260L434 87L0 87z"/>
    <path style="fill:#3b6da5; stroke:none;" d="M0 172L0 173L432 173L432 258L0 258L0 259L433 259L433 172L0 172z"/>
    <path style="fill:#21478b; stroke:none;" d="M0 173L0 258L432 258L432 173L0 173z"/>
  </svg>
</template>

<script>
export default {
  name: "Nl"
}
</script>

<style scoped>

</style>
